<!--Locked Videos-->
<!-- <greco-locked-gallery *ngIf="user" [user]="user"> </greco-locked-gallery> -->
<div class="no-events" *ngIf="!user">
  <p>
    Oops! Looks like you're not signed in!
    <a [routerLink]="" (click)="signIn()" *ngIf="!user">Sign in</a> to search for videos!
  </p>
</div>
<!--<greco-user-video-perks></greco-user-video-perks>-->
